module.exports = __webpack_public_path__ + "static/7acre3-8f0d8b24a875ac40db713050eed46026.jpg";